<template>
  <div
    @touchstart="menuTypeTouched = true"
    @touchend="menuTypeTouched = false"
    class="transition transform relative h-32 sm:h-48 overflow-hidden rounded-lg object-cover"
  >
    <img
      alt="image"
      :class="[
        index == activeMenuTypeIndex ? 'animate-teaser ' : '',
        menuTypeTouched ? 'scale-110' : '',
      ]"
      class="h-full w-full object-cover transition-all transform duration-300 ease-in-out"
      :src="image"
    />
    <hr
      id="menuTypeDiv"
      class="absolute top-0 left-0 h-full w-full bg-gradient-to-t from-black"
    />
    <p class="absolute inset-x-0 bottom-0 px-2 text-white">
      {{ title }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuTypeTouched: false,
    };
  },
  props: {
    title: String,
    image: String,
    index: Number,
    activeMenuTypeIndex: Number,
  },
};
</script>
